/* unplugin-vue-components disabled */
import {INDUSTRIES_ICONS, INDUSTRIES_TITLES} from 'consts/industries'
import MdContent from 'components/md-content'
import SaveDoc from '../save-doc.vue'
import FollowBtn from './follow-btn.vue'
import $companies, {Company} from 'stores/companies'

export default {
  components: {MdContent, FollowBtn, SaveDoc},
  props: {
    info: {type: Object, default: undefined},
    loading: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
  },
  emits: ['save'],
  data() {
    return {
      user_company_id: undefined,
      on_follow: $utils.timers.debounce(this.followCompany, 500)
    }
  },
  computed: {
    name() {
      return this.info?.name
    },
    logo_url() {
      return this.info?.logo_url
    },
    hq_address() {
      return this.info?.hq_address
    },
    industry() {
      return this.info?.industry
    },
    summary() {
      return this.info?.summary
    },
    website_url() {
      return this.info?.website_url
    },
    linkedin_id() {
      return this.info?.linkedin_id
    },
    company_id() {
      return this.info?.user_company_id
    },
    linkedin_url() {
      return this.linkedin_id ? `https://linkedin.com/company/${this.linkedin_id}` : undefined
    },
    industry_title(){
      return INDUSTRIES_TITLES[this.industry]
    },
    industry_icon(){
      return INDUSTRIES_ICONS[this.industry]
    },
    following() {
      return !!this.user_company_id
    }
  },
  watch: {
    'company_id': {
      handler(curr_id) {
        this.user_company_id = curr_id
      },
      immediate: true
    }
  },
  beforeUnmount() {
    this.on_follow.abort()
  },
  methods: {
    openLinkedin() {
      window.open(this.linkedin_url, '_blank')
    },
    openWebsite() {
      window.open(this.website_url, '_blank')
    },
    async followCompany() {
      if (this.user_company_id) {
        const company = new Company({id: this.user_company_id})
        await company.drop()
        this.user_company_id = undefined
      }
      else {
        const company_name = this.name
        const linkedin_id = this.linkedin_id
        const shared_company_id = this.info?.sh_company_id || this.info?.shared_company_id
        const company = await $companies.newCompany({company_name, linkedin_id, shared_company_id})
        this.user_company_id = company.id
      }
    }
  }
}
